import {
  Col,
  Form,
  Row,
  Modal,
  Button,
  Alert
} from 'react-bootstrap';

import styles from './CipaInscricao.module.css';
import cipaUnidades from '../../helpers/cipaUnidades';
import editalCipaa2026 from '../../assets/pdfs/edital-cipaa-2026.pdf';

const CipaInscricao = props => {
  return (
    <>
      <div className={styles.title}>Formulário de Inscrição CIPAA</div>
      <div className={styles.subtitle}>FeSaúde <span className={styles.uppercase}>Gestão</span> 2026/2027</div>
      <div className={styles.subtitle}><span className={styles.uppercase}>Período de Inscrição</span> - 16/06/2026 a 30/06/2026</div>

      <Alert variant="warning" className="mt-4">
        <Alert.Heading>Importante!</Alert.Heading>
        <p>
          Sua inscrição só será confirmada após a análise da equipe responsável e a finalização da solicitação abaixo.
        </p>
      </Alert>
      <Row>
        <Col sm={12}>
          <Form.Group controlId="cipaInscricaoNome" className="mt-4">
            <Form.Label>*Nome completo:</Form.Label>
            <Form.Control
              type="text"
              required
              name="cipaInscricaoNome"
              value={props.nome}
              readOnly
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="cipaInscricaoUnidade" className="mt-4">
            <Form.Label>*Unidade em que atua:</Form.Label>
            <Form.Select
              className="border border-secondary"
              name="cipaInscricaoUnidade"
              onChange={e => props.handleCipaInscricaoUnidade(e)}
              value={props.cipaInscricaoUnidade}
            >
              <option value="">Selecione a unidade</option>
              {cipaUnidades.map(item => (
                <option key={item} value={item}>{item}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="cipaInscricaoCargo" className="mt-4">
            <Form.Label>*Cargo/Função:</Form.Label>
            <Form.Control
              type="text"
              required
              name="cipaInscricaoCargo"
              onChange={e => props.handleCipaInscricaoCargo(e)}
              value={props.cipaInscricaoCargo}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="cipaInscricaoEmail" className="mt-4">
            <Form.Label>*e-mail:</Form.Label>
            <Form.Control
              type="text"
              required
              name="cipaInscricaoEmail"
              value={props.email}
              readOnly
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <Form.Group controlId="cipaInscricaoMatricula" className="mt-4">
            <Form.Label>*Matrícula:</Form.Label>
            <Form.Control
              type="text"
              required
              name="cipaInscricaoMatricula"
              value={props.matricula}
              readOnly
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Form.Group controlId="cipaInscricaoSobre" className="mt-4">
          <Form.Label className={styles.sobre}>*Sobre a inscrição:</Form.Label>
          <Form.Check
            name="cipaInscricaoSobre"
            type="checkbox"
            id="cipaInscricaoSobre"
            value="ok"
            onChange={e => props.handleCipaInscricaoSobre(e)}
            label={
              <span>
                Declaro que li o
                <a
                  href={editalCipaa2026}
                  target='_blank'
                  rel='noopener noreferrer'
                  className={styles.edital}
                >
                  &nbsp;Edital do Processo Eleitoral da CIPAA&nbsp;
                </a>
                - Gestão 2026/2027 e em concordância desejo me inscrever.
              </span>
            }
          />
        </Form.Group>
      </Row>

      <Modal show={props.showCipaInscricaoModal} onHide={props.handleCipaInscricaoModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.cipaInscricaoError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleCipaInscricaoModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CipaInscricao;
